import React from 'react';
import '../App.css';

export default class BasicModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = { 
      modalTop: this.props.modalTop,
      modalBottom: this.props.modalBottom,
    };
  }

  hideModal(e) {
    if (e.target.id === 'overlayBackground' || e.target.id === 'closeModal') { 
      this.props.app.setState({modal: ''});
    }
  }

  render() {
    let style = {};
    if (this.props.height) {
      style['height'] = this.props.height;
    } 
    console.log('       STYLE IS: ' + JSON.stringify(style));
    return(
      <div id='overlayBackground' onClick={(e) => this.hideModal(e)} className='greyOverlay'>
        <div className='basicModal' style={style}>
          <div id='closeModal' className='closeModalButton' onClick={(e) => this.hideModal.bind(e)}>X</div>
          <center> 
          <b>{this.state.modalTop}</b>
          <br />
          {this.state.modalBottom}
          <br />
          {this.props.buttonA ? <button className='postSubmitButton' onClick={(e) => this.props.buttonA(e)}>{this.props.buttonAlabel}</button> : ''}
          &nbsp;
          {this.props.buttonB ? <button className='postSubmitButton' onClick={(e) => this.props.buttonB(e)}>{this.props.buttonBlabel}</button> : ''}
          &nbsp;
          {this.props.buttonC ? <button className='postSubmitButton' onClick={(e) => this.props.buttonC(e)}>{this.props.buttonClabel}</button> : ''}
          </center>
        </div>
      </div>
    );
  }
}

